<template>
  <div class="landingPage">
    <app-header></app-header>
    <h1>ReportBugPage</h1>
    <app-footer></app-footer>
  </div>
</template>

<script>
export default {
	name: 'ReportBugPage',
	props: {
	},
	metaInfo: {
		title: 'Report a Bug | Contact Us'
	}
}
</script>

<style></style>
